import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import IsProdEnvironment from '~/app/utils/is-production-environment';

export const local: PartialCarConfiguration = {
	hasJetStream: true,
	showCaESummaryText: true,
	engineCardKeyfacts: ['acceleration', 'maxPowerHp', 'chargingTime'],
	showEECLabel: true,
	wltpInfo: {
		url: {
			url: 'https://mediaservice.audi.com/media/eec-label/FR/fr/A/0',
			pathParams: {},
			queryParams: [],
		},
		showCarModel: true,
		energyClass: 'A',
	},
	financeDomain: 'AUDI.FR',
	enableFinancingServices: !IsProdEnvironment(),
	hideMonthlyRates: IsProdEnvironment(),
	nextBestActions: [
		{
			icon: '',
			description: 'Réserver votre essai',
			labelText: 'Essai',
			target: '_blank',
			trackingName: 'testdrive',
			url: 'https://france.my.audi.com/information/?formid=586&carlineid={{carlineId}}&audicode={{audiCode}}',
		},
		{
			icon: 'used-cars',
			description: 'Voir les véhicules neufs disponibles',
			labelText: 'Voir les véhicules neufs disponibles',
			target: '_blank',

			trackingName: 'go to vtp',
			url: 'https://www.audi.fr/fr/web/fr/nouvelles-voitures.html#filter=carline.{{carlineId}} ',
		},
	],
	summaryFooterCta: {
		icon: 'code',
		description: 'Générer un Audi Code',
		labelText: 'Générer un Audi Code',
		target: '_blank',

		trackingName: 'show audicode',
		url: '',
	},
};
